import React, { useState, useEffect } from 'react'
import { Chart } from 'primereact/chart'
import { chartColorVariants } from './chartsUtil'

const PieChart = ({ data }) => {
    const [chartData, setChartData] = useState({})
    const [chartOptions, setChartOptions] = useState({})

    useEffect(() => {
        const options = {
            plugins: {
                legend: {
                    labels: {
                        usePointStyle: true,
                    },
                },
            },
        }

        let finalisedChartData = data
        let ds = data?.['datasets']?.[0] || {}
        const dsData = ds['data'] || []

        ds['borderColor'] = []
        ds['backgroundColor'] = []

        const documentStyle = getComputedStyle(document.documentElement)

        for (const i in dsData) {
            const colorVariant = chartColorVariants[i]

            if (colorVariant) {
                ds['borderColor'].push(
                    documentStyle.getPropertyValue('--bs-' + colorVariant)
                )
                ds['backgroundColor'].push(
                    documentStyle.getPropertyValue('--bs-' + colorVariant) +
                        '80'
                )
            }
        }

        setChartData(finalisedChartData)
        setChartOptions(options)
    }, [data])

    return (
        <>
            <Chart
                type="pie"
                data={chartData}
                options={chartOptions}
                className="w-100 h-100"
            />
        </>
    )
}

export default PieChart
